/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * Inspection Service API
 * Inspection and scope of work management for CTE platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddEquipmentToScopeOfWorkRequest,
  AddEquipmentToScopeOfWorkResponse,
  CompleteInspectionRequest,
  CreateInspectionRequest,
  CreateScopeOfWorkRequest,
  DocumentSummaryResponse,
  ErrorResponse,
  FieldVerificationListResponse,
  FieldVerificationResponse,
  GetHACFormCatalogParams,
  GetInspectionSummaryParams,
  HACFormCatalogResponse,
  HACFormResponse,
  InspectionListResponse,
  InspectionPhotoResponse,
  InspectionResponse,
  InspectionSummaryResponse,
  ListInspectionsParams,
  ListScopeOfWorksParams,
  PurgeSiteInspectionsResponse,
  RecordFieldVerificationRequest,
  RejectInspectionRequest,
  RemoveEquipmentFromScopeOfWorkRequest,
  RemoveEquipmentFromScopeOfWorkResponse,
  ScopeOfWorkDetailsResponse,
  ScopeOfWorkResponse,
  SiteInspectionSettingsDTO,
  SiteScheduleSettingsDTO,
  SubmitHACFormRequest,
  UpdateInspectionRequest,
  UpdateScopeOfWorkRequest,
  UpdateSiteInspectionSettingsRequest,
  UpdateSiteScheduleSettingsRequest,
  UpsertHACFormDraftRequest,
  ValidationErrorResponse
} from './model';

import { customFetch } from './custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListScopeOfWorksUrl = (params: ListScopeOfWorksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/scope-of-works?${stringifiedParams}` : `/api/scope-of-works`
}

/**
 * **Auth:** `site` is the authorisation anchor — the caller must
 * hold a site claim for it (admin bypasses). Listing across all
 * sites is not exposed.
 * @summary List scope of works
 */
export const listScopeOfWorks = async (params: ListScopeOfWorksParams, options?: RequestInit): Promise<ScopeOfWorkResponse[]> => {

  return customFetch<ScopeOfWorkResponse[]>(getListScopeOfWorksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListScopeOfWorksQueryKey = (params?: ListScopeOfWorksParams,) => {
    return [
    `/api/scope-of-works`, ...(params ? [params] : [])
    ] as const;
    }


export const getListScopeOfWorksQueryOptions = <TData = Awaited<ReturnType<typeof listScopeOfWorks>>, TError = ErrorResponse>(params: ListScopeOfWorksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScopeOfWorks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListScopeOfWorksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listScopeOfWorks>>> = ({ signal }) => listScopeOfWorks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listScopeOfWorks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListScopeOfWorksQueryResult = NonNullable<Awaited<ReturnType<typeof listScopeOfWorks>>>
export type ListScopeOfWorksQueryError = ErrorResponse


export function useListScopeOfWorks<TData = Awaited<ReturnType<typeof listScopeOfWorks>>, TError = ErrorResponse>(
 params: ListScopeOfWorksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScopeOfWorks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listScopeOfWorks>>,
          TError,
          Awaited<ReturnType<typeof listScopeOfWorks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScopeOfWorks<TData = Awaited<ReturnType<typeof listScopeOfWorks>>, TError = ErrorResponse>(
 params: ListScopeOfWorksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScopeOfWorks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listScopeOfWorks>>,
          TError,
          Awaited<ReturnType<typeof listScopeOfWorks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScopeOfWorks<TData = Awaited<ReturnType<typeof listScopeOfWorks>>, TError = ErrorResponse>(
 params: ListScopeOfWorksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScopeOfWorks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List scope of works
 */

export function useListScopeOfWorks<TData = Awaited<ReturnType<typeof listScopeOfWorks>>, TError = ErrorResponse>(
 params: ListScopeOfWorksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScopeOfWorks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListScopeOfWorksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateScopeOfWorkUrl = () => {




  return `/api/scope-of-works`
}

/**
 * **Auth:** manager floor (manager or admin) + site claim on the
 * requested `siteId`. Admin bypasses the site-claim check.
 * Inspectors and viewers are rejected — SOW creation is a planning
 * action.
 * @summary Create a new scope of work
 */
export const createScopeOfWork = async (createScopeOfWorkRequest: CreateScopeOfWorkRequest, options?: RequestInit): Promise<ScopeOfWorkResponse> => {

  return customFetch<ScopeOfWorkResponse>(getCreateScopeOfWorkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createScopeOfWorkRequest)
  }
);}





export const getCreateScopeOfWorkMutationOptions = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScopeOfWork>>, TError,{data: CreateScopeOfWorkRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createScopeOfWork>>, TError,{data: CreateScopeOfWorkRequest}, TContext> => {

const mutationKey = ['createScopeOfWork'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createScopeOfWork>>, {data: CreateScopeOfWorkRequest}> = (props) => {
          const {data} = props ?? {};

          return  createScopeOfWork(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateScopeOfWorkMutationResult = NonNullable<Awaited<ReturnType<typeof createScopeOfWork>>>
    export type CreateScopeOfWorkMutationBody = CreateScopeOfWorkRequest
    export type CreateScopeOfWorkMutationError = ErrorResponse | ValidationErrorResponse

    /**
 * @summary Create a new scope of work
 */
export const useCreateScopeOfWork = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScopeOfWork>>, TError,{data: CreateScopeOfWorkRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createScopeOfWork>>,
        TError,
        {data: CreateScopeOfWorkRequest},
        TContext
      > => {
      return useMutation(getCreateScopeOfWorkMutationOptions(options), queryClient);
    }

export const getGetScopeOfWorkUrl = (id: string,) => {




  return `/api/scope-of-works/${id}`
}

/**
 * **Auth:** viewer floor (any authenticated role) + site claim on
 * the loaded SOW's site. Admin bypasses the site-claim check. The
 * claim check runs after the record is loaded so callers cannot
 * probe IDs across sites.
 * @summary Get scope of work by ID with inspections
 */
export const getScopeOfWork = async (id: string, options?: RequestInit): Promise<ScopeOfWorkDetailsResponse> => {

  return customFetch<ScopeOfWorkDetailsResponse>(getGetScopeOfWorkUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetScopeOfWorkQueryKey = (id: string,) => {
    return [
    `/api/scope-of-works/${id}`
    ] as const;
    }


export const getGetScopeOfWorkQueryOptions = <TData = Awaited<ReturnType<typeof getScopeOfWork>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScopeOfWorkQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScopeOfWork>>> = ({ signal }) => getScopeOfWork(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScopeOfWork>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetScopeOfWorkQueryResult = NonNullable<Awaited<ReturnType<typeof getScopeOfWork>>>
export type GetScopeOfWorkQueryError = ErrorResponse


export function useGetScopeOfWork<TData = Awaited<ReturnType<typeof getScopeOfWork>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScopeOfWork>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScopeOfWork>>,
          TError,
          Awaited<ReturnType<typeof getScopeOfWork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScopeOfWork<TData = Awaited<ReturnType<typeof getScopeOfWork>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScopeOfWork>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScopeOfWork>>,
          TError,
          Awaited<ReturnType<typeof getScopeOfWork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScopeOfWork<TData = Awaited<ReturnType<typeof getScopeOfWork>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get scope of work by ID with inspections
 */

export function useGetScopeOfWork<TData = Awaited<ReturnType<typeof getScopeOfWork>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScopeOfWorkQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateScopeOfWorkUrl = (id: string,) => {




  return `/api/scope-of-works/${id}`
}

/**
 * **Auth:** manager floor (manager or admin) + site claim on the
 * loaded SOW's site. Admin bypasses the site-claim check.
 * Inspectors and viewers are rejected.
 * @summary Update scope of work
 */
export const updateScopeOfWork = async (id: string,
    updateScopeOfWorkRequest: UpdateScopeOfWorkRequest, options?: RequestInit): Promise<ScopeOfWorkResponse> => {

  return customFetch<ScopeOfWorkResponse>(getUpdateScopeOfWorkUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateScopeOfWorkRequest)
  }
);}





export const getUpdateScopeOfWorkMutationOptions = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScopeOfWork>>, TError,{id: string;data: UpdateScopeOfWorkRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateScopeOfWork>>, TError,{id: string;data: UpdateScopeOfWorkRequest}, TContext> => {

const mutationKey = ['updateScopeOfWork'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateScopeOfWork>>, {id: string;data: UpdateScopeOfWorkRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateScopeOfWork(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateScopeOfWorkMutationResult = NonNullable<Awaited<ReturnType<typeof updateScopeOfWork>>>
    export type UpdateScopeOfWorkMutationBody = UpdateScopeOfWorkRequest
    export type UpdateScopeOfWorkMutationError = ErrorResponse | ValidationErrorResponse

    /**
 * @summary Update scope of work
 */
export const useUpdateScopeOfWork = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScopeOfWork>>, TError,{id: string;data: UpdateScopeOfWorkRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateScopeOfWork>>,
        TError,
        {id: string;data: UpdateScopeOfWorkRequest},
        TContext
      > => {
      return useMutation(getUpdateScopeOfWorkMutationOptions(options), queryClient);
    }

export const getDeleteScopeOfWorkUrl = (id: string,) => {




  return `/api/scope-of-works/${id}`
}

/**
 * **Auth:** manager floor (manager or admin) + site claim on the
 * loaded SOW's site. Admin bypasses the site-claim check.
 * Inspectors and viewers are rejected.
 * @summary Delete scope of work
 */
export const deleteScopeOfWork = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteScopeOfWorkUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteScopeOfWorkMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteScopeOfWork>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteScopeOfWork>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteScopeOfWork'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteScopeOfWork>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteScopeOfWork(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteScopeOfWorkMutationResult = NonNullable<Awaited<ReturnType<typeof deleteScopeOfWork>>>

    export type DeleteScopeOfWorkMutationError = ErrorResponse

    /**
 * @summary Delete scope of work
 */
export const useDeleteScopeOfWork = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteScopeOfWork>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteScopeOfWork>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteScopeOfWorkMutationOptions(options), queryClient);
    }

export const getScheduleScopeOfWorkUrl = (id: string,) => {




  return `/api/scope-of-works/${id}/schedule`
}

/**
 * Transitions the SOW from PLANNING to SCHEDULED and updates all
 * associated inspections to SCHEDULED status.
 *
 * **Auth:** manager floor (manager or admin) + site claim on the
 * loaded SOW's site. Admin bypasses the site-claim check.
 * Inspectors and viewers are rejected.
 * @summary Move scope of work to scheduled phase
 */
export const scheduleScopeOfWork = async (id: string, options?: RequestInit): Promise<ScopeOfWorkResponse> => {

  return customFetch<ScopeOfWorkResponse>(getScheduleScopeOfWorkUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getScheduleScopeOfWorkMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleScopeOfWork>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof scheduleScopeOfWork>>, TError,{id: string}, TContext> => {

const mutationKey = ['scheduleScopeOfWork'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scheduleScopeOfWork>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  scheduleScopeOfWork(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScheduleScopeOfWorkMutationResult = NonNullable<Awaited<ReturnType<typeof scheduleScopeOfWork>>>

    export type ScheduleScopeOfWorkMutationError = ErrorResponse

    /**
 * @summary Move scope of work to scheduled phase
 */
export const useScheduleScopeOfWork = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleScopeOfWork>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scheduleScopeOfWork>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getScheduleScopeOfWorkMutationOptions(options), queryClient);
    }

export const getCancelScopeOfWorkUrl = (id: string,) => {




  return `/api/scope-of-works/${id}/cancel`
}

/**
 * Transitions the SOW from PLANNING / SCHEDULED / IN_PROGRESS to
 * CANCELLED. Cascades every non-terminal child inspection to CANCELLED
 * in the same transaction. Already-COMPLETED children are preserved.
 *
 * **Auth:** manager floor (manager or admin) + site claim on the
 * loaded SOW's site. Admin bypasses the site-claim check.
 * Inspectors and viewers are rejected.
 * @summary Cancel a scope of work
 */
export const cancelScopeOfWork = async (id: string, options?: RequestInit): Promise<ScopeOfWorkResponse> => {

  return customFetch<ScopeOfWorkResponse>(getCancelScopeOfWorkUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelScopeOfWorkMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelScopeOfWork>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelScopeOfWork>>, TError,{id: string}, TContext> => {

const mutationKey = ['cancelScopeOfWork'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelScopeOfWork>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelScopeOfWork(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelScopeOfWorkMutationResult = NonNullable<Awaited<ReturnType<typeof cancelScopeOfWork>>>

    export type CancelScopeOfWorkMutationError = ErrorResponse

    /**
 * @summary Cancel a scope of work
 */
export const useCancelScopeOfWork = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelScopeOfWork>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelScopeOfWork>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getCancelScopeOfWorkMutationOptions(options), queryClient);
    }

export const getAddEquipmentToScopeOfWorkUrl = (id: string,) => {




  return `/api/scope-of-works/${id}/equipment`
}

/**
 * **Auth:** manager floor (manager or admin) + site claim on the
 * loaded SOW's site. Admin bypasses the site-claim check.
 * Inspectors and viewers are rejected.
 * @summary Add equipment to scope of work
 */
export const addEquipmentToScopeOfWork = async (id: string,
    addEquipmentToScopeOfWorkRequest: AddEquipmentToScopeOfWorkRequest, options?: RequestInit): Promise<AddEquipmentToScopeOfWorkResponse> => {

  return customFetch<AddEquipmentToScopeOfWorkResponse>(getAddEquipmentToScopeOfWorkUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addEquipmentToScopeOfWorkRequest)
  }
);}





export const getAddEquipmentToScopeOfWorkMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addEquipmentToScopeOfWork>>, TError,{id: string;data: AddEquipmentToScopeOfWorkRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addEquipmentToScopeOfWork>>, TError,{id: string;data: AddEquipmentToScopeOfWorkRequest}, TContext> => {

const mutationKey = ['addEquipmentToScopeOfWork'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addEquipmentToScopeOfWork>>, {id: string;data: AddEquipmentToScopeOfWorkRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  addEquipmentToScopeOfWork(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddEquipmentToScopeOfWorkMutationResult = NonNullable<Awaited<ReturnType<typeof addEquipmentToScopeOfWork>>>
    export type AddEquipmentToScopeOfWorkMutationBody = AddEquipmentToScopeOfWorkRequest
    export type AddEquipmentToScopeOfWorkMutationError = ErrorResponse

    /**
 * @summary Add equipment to scope of work
 */
export const useAddEquipmentToScopeOfWork = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addEquipmentToScopeOfWork>>, TError,{id: string;data: AddEquipmentToScopeOfWorkRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addEquipmentToScopeOfWork>>,
        TError,
        {id: string;data: AddEquipmentToScopeOfWorkRequest},
        TContext
      > => {
      return useMutation(getAddEquipmentToScopeOfWorkMutationOptions(options), queryClient);
    }

export const getRemoveEquipmentFromScopeOfWorkUrl = (id: string,) => {




  return `/api/scope-of-works/${id}/equipment`
}

/**
 * **Auth:** manager floor (manager or admin) + site claim on the
 * loaded SOW's site. Admin bypasses the site-claim check.
 * Inspectors and viewers are rejected.
 * @summary Remove equipment from scope of work
 */
export const removeEquipmentFromScopeOfWork = async (id: string,
    removeEquipmentFromScopeOfWorkRequest: RemoveEquipmentFromScopeOfWorkRequest, options?: RequestInit): Promise<RemoveEquipmentFromScopeOfWorkResponse> => {

  return customFetch<RemoveEquipmentFromScopeOfWorkResponse>(getRemoveEquipmentFromScopeOfWorkUrl(id),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(removeEquipmentFromScopeOfWorkRequest)
  }
);}





export const getRemoveEquipmentFromScopeOfWorkMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeEquipmentFromScopeOfWork>>, TError,{id: string;data: RemoveEquipmentFromScopeOfWorkRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeEquipmentFromScopeOfWork>>, TError,{id: string;data: RemoveEquipmentFromScopeOfWorkRequest}, TContext> => {

const mutationKey = ['removeEquipmentFromScopeOfWork'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeEquipmentFromScopeOfWork>>, {id: string;data: RemoveEquipmentFromScopeOfWorkRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  removeEquipmentFromScopeOfWork(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveEquipmentFromScopeOfWorkMutationResult = NonNullable<Awaited<ReturnType<typeof removeEquipmentFromScopeOfWork>>>
    export type RemoveEquipmentFromScopeOfWorkMutationBody = RemoveEquipmentFromScopeOfWorkRequest
    export type RemoveEquipmentFromScopeOfWorkMutationError = ErrorResponse

    /**
 * @summary Remove equipment from scope of work
 */
export const useRemoveEquipmentFromScopeOfWork = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeEquipmentFromScopeOfWork>>, TError,{id: string;data: RemoveEquipmentFromScopeOfWorkRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeEquipmentFromScopeOfWork>>,
        TError,
        {id: string;data: RemoveEquipmentFromScopeOfWorkRequest},
        TContext
      > => {
      return useMutation(getRemoveEquipmentFromScopeOfWorkMutationOptions(options), queryClient);
    }

export const getGetInspectionSummaryUrl = (params?: GetInspectionSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inspections/summary?${stringifiedParams}` : `/api/inspections/summary`
}

/**
 * Site scope is derived from the authenticated user's site claims (X-Site-Claims header).
 * Optionally narrow the summary to a single site by passing the `siteId` query param —
 * the site must be present in the caller's claims or the request is rejected.
 * @summary Get inspection summary counts for dashboard
 */
export const getInspectionSummary = async (params?: GetInspectionSummaryParams, options?: RequestInit): Promise<InspectionSummaryResponse> => {

  return customFetch<InspectionSummaryResponse>(getGetInspectionSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInspectionSummaryQueryKey = (params?: GetInspectionSummaryParams,) => {
    return [
    `/api/inspections/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetInspectionSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getInspectionSummary>>, TError = ErrorResponse>(params?: GetInspectionSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspectionSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInspectionSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInspectionSummary>>> = ({ signal }) => getInspectionSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInspectionSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInspectionSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getInspectionSummary>>>
export type GetInspectionSummaryQueryError = ErrorResponse


export function useGetInspectionSummary<TData = Awaited<ReturnType<typeof getInspectionSummary>>, TError = ErrorResponse>(
 params: undefined |  GetInspectionSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspectionSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInspectionSummary>>,
          TError,
          Awaited<ReturnType<typeof getInspectionSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInspectionSummary<TData = Awaited<ReturnType<typeof getInspectionSummary>>, TError = ErrorResponse>(
 params?: GetInspectionSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspectionSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInspectionSummary>>,
          TError,
          Awaited<ReturnType<typeof getInspectionSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInspectionSummary<TData = Awaited<ReturnType<typeof getInspectionSummary>>, TError = ErrorResponse>(
 params?: GetInspectionSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspectionSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get inspection summary counts for dashboard
 */

export function useGetInspectionSummary<TData = Awaited<ReturnType<typeof getInspectionSummary>>, TError = ErrorResponse>(
 params?: GetInspectionSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspectionSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInspectionSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPurgeSiteInspectionsUrl = (siteId: string,) => {




  return `/api/sites/${siteId}/inspections/purge`
}

/**
 * Empties a site's inspection records while the site, its equipment and
 * its defects stay in place. Each inspection goes through the standard
 * delete, so one `inspection.deleted` event goes out per row and
 * document-svc removes the HAC sheets, photos and attachments filed under
 * it. One `audit.site.recorded` summary with action `purged` records the
 * count on the site's timeline. Scopes of work are not removed.
 *
 * **Auth:** platform admin only. A manager with a claim on the site can
 * delete inspections one at a time, but cannot empty the site in one call.
 * @summary Delete every inspection on a site
 */
export const purgeSiteInspections = async (siteId: string, options?: RequestInit): Promise<PurgeSiteInspectionsResponse> => {

  return customFetch<PurgeSiteInspectionsResponse>(getPurgeSiteInspectionsUrl(siteId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getPurgeSiteInspectionsMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purgeSiteInspections>>, TError,{siteId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof purgeSiteInspections>>, TError,{siteId: string}, TContext> => {

const mutationKey = ['purgeSiteInspections'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purgeSiteInspections>>, {siteId: string}> = (props) => {
          const {siteId} = props ?? {};

          return  purgeSiteInspections(siteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PurgeSiteInspectionsMutationResult = NonNullable<Awaited<ReturnType<typeof purgeSiteInspections>>>

    export type PurgeSiteInspectionsMutationError = ErrorResponse

    /**
 * @summary Delete every inspection on a site
 */
export const usePurgeSiteInspections = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purgeSiteInspections>>, TError,{siteId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof purgeSiteInspections>>,
        TError,
        {siteId: string},
        TContext
      > => {
      return useMutation(getPurgeSiteInspectionsMutationOptions(options), queryClient);
    }

export const getListInspectionsUrl = (params?: ListInspectionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inspections?${stringifiedParams}` : `/api/inspections`
}

/**
 * **Auth:** viewer floor + site claim. When `siteId` is supplied the
 * caller must hold a claim for it; otherwise the result is filtered
 * to the caller's claims. Admin bypasses the site-claim check.
 * @summary List inspections with pagination
 */
export const listInspections = async (params?: ListInspectionsParams, options?: RequestInit): Promise<InspectionListResponse> => {

  return customFetch<InspectionListResponse>(getListInspectionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInspectionsInfiniteQueryKey = (params?: ListInspectionsParams,) => {
    return [
    'infinite', `/api/inspections`, ...(params ? [params] : [])
    ] as const;
    }

export const getListInspectionsQueryKey = (params?: ListInspectionsParams,) => {
    return [
    `/api/inspections`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInspectionsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listInspections>>, ListInspectionsParams['offset']>, TError = ErrorResponse>(params?: ListInspectionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listInspections>>, TError, TData, QueryKey, ListInspectionsParams['offset']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInspectionsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInspections>>, QueryKey, ListInspectionsParams['offset']> = ({ signal, pageParam }) => listInspections({...params, 'offset': pageParam ?? params?.['offset']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listInspections>>, TError, TData, QueryKey, ListInspectionsParams['offset']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInspectionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listInspections>>>
export type ListInspectionsInfiniteQueryError = ErrorResponse


export function useListInspectionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listInspections>>, ListInspectionsParams['offset']>, TError = ErrorResponse>(
 params: undefined |  ListInspectionsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listInspections>>, TError, TData, QueryKey, ListInspectionsParams['offset']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInspections>>,
          TError,
          Awaited<ReturnType<typeof listInspections>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInspectionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listInspections>>, ListInspectionsParams['offset']>, TError = ErrorResponse>(
 params?: ListInspectionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listInspections>>, TError, TData, QueryKey, ListInspectionsParams['offset']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInspections>>,
          TError,
          Awaited<ReturnType<typeof listInspections>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInspectionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listInspections>>, ListInspectionsParams['offset']>, TError = ErrorResponse>(
 params?: ListInspectionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listInspections>>, TError, TData, QueryKey, ListInspectionsParams['offset']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List inspections with pagination
 */

export function useListInspectionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listInspections>>, ListInspectionsParams['offset']>, TError = ErrorResponse>(
 params?: ListInspectionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listInspections>>, TError, TData, QueryKey, ListInspectionsParams['offset']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInspectionsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListInspectionsQueryOptions = <TData = Awaited<ReturnType<typeof listInspections>>, TError = ErrorResponse>(params?: ListInspectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInspectionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInspections>>> = ({ signal }) => listInspections(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInspections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInspectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listInspections>>>
export type ListInspectionsQueryError = ErrorResponse


export function useListInspections<TData = Awaited<ReturnType<typeof listInspections>>, TError = ErrorResponse>(
 params: undefined |  ListInspectionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInspections>>,
          TError,
          Awaited<ReturnType<typeof listInspections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInspections<TData = Awaited<ReturnType<typeof listInspections>>, TError = ErrorResponse>(
 params?: ListInspectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInspections>>,
          TError,
          Awaited<ReturnType<typeof listInspections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInspections<TData = Awaited<ReturnType<typeof listInspections>>, TError = ErrorResponse>(
 params?: ListInspectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List inspections with pagination
 */

export function useListInspections<TData = Awaited<ReturnType<typeof listInspections>>, TError = ErrorResponse>(
 params?: ListInspectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInspectionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateInspectionUrl = () => {




  return `/api/inspections`
}

/**
 * **Auth:** inspector floor (inspector, manager or admin) + site claim
 * on the requested `siteId`. Admin bypasses the site-claim check.
 * Viewers are rejected — ad-hoc inspection creation is a planning action.
 * @summary Create a new inspection
 */
export const createInspection = async (createInspectionRequest: CreateInspectionRequest, options?: RequestInit): Promise<InspectionResponse> => {

  return customFetch<InspectionResponse>(getCreateInspectionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createInspectionRequest)
  }
);}





export const getCreateInspectionMutationOptions = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInspection>>, TError,{data: CreateInspectionRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInspection>>, TError,{data: CreateInspectionRequest}, TContext> => {

const mutationKey = ['createInspection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInspection>>, {data: CreateInspectionRequest}> = (props) => {
          const {data} = props ?? {};

          return  createInspection(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInspectionMutationResult = NonNullable<Awaited<ReturnType<typeof createInspection>>>
    export type CreateInspectionMutationBody = CreateInspectionRequest
    export type CreateInspectionMutationError = ErrorResponse | ValidationErrorResponse

    /**
 * @summary Create a new inspection
 */
export const useCreateInspection = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInspection>>, TError,{data: CreateInspectionRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInspection>>,
        TError,
        {data: CreateInspectionRequest},
        TContext
      > => {
      return useMutation(getCreateInspectionMutationOptions(options), queryClient);
    }

export const getGetInspectionUrl = (id: string,) => {




  return `/api/inspections/${id}`
}

/**
 * **Auth:** viewer floor + site claim on the loaded inspection's
 * site. Admin bypasses the site-claim check. The claim check runs
 * after the record is loaded so callers cannot probe IDs across
 * sites.
 * @summary Get inspection by ID
 */
export const getInspection = async (id: string, options?: RequestInit): Promise<InspectionResponse> => {

  return customFetch<InspectionResponse>(getGetInspectionUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInspectionQueryKey = (id: string,) => {
    return [
    `/api/inspections/${id}`
    ] as const;
    }


export const getGetInspectionQueryOptions = <TData = Awaited<ReturnType<typeof getInspection>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInspectionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInspection>>> = ({ signal }) => getInspection(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInspection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInspectionQueryResult = NonNullable<Awaited<ReturnType<typeof getInspection>>>
export type GetInspectionQueryError = ErrorResponse


export function useGetInspection<TData = Awaited<ReturnType<typeof getInspection>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInspection>>,
          TError,
          Awaited<ReturnType<typeof getInspection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInspection<TData = Awaited<ReturnType<typeof getInspection>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInspection>>,
          TError,
          Awaited<ReturnType<typeof getInspection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInspection<TData = Awaited<ReturnType<typeof getInspection>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get inspection by ID
 */

export function useGetInspection<TData = Awaited<ReturnType<typeof getInspection>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInspectionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateInspectionUrl = (id: string,) => {




  return `/api/inspections/${id}`
}

/**
 * **Auth:** inspector floor (inspector, manager, or admin) + site
 * claim. Admin bypasses the site-claim check. Viewers are rejected.
 *
 * Field-level role gate (RUB-235): planning fields (`scopeOfWorkId`,
 * `scheduledDate`, `clearScheduledDate`, `status`, `inspectionType`)
 * are admin-only. Result fields (`findings`, `documentId`) are
 * editable by any inspector with the site claim, except once the
 * inspection is terminal (COMPLETED → admin-only escape hatch;
 * CANCELLED → frozen for everyone).
 * @summary Update inspection
 */
export const updateInspection = async (id: string,
    updateInspectionRequest: UpdateInspectionRequest, options?: RequestInit): Promise<InspectionResponse> => {

  return customFetch<InspectionResponse>(getUpdateInspectionUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateInspectionRequest)
  }
);}





export const getUpdateInspectionMutationOptions = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInspection>>, TError,{id: string;data: UpdateInspectionRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInspection>>, TError,{id: string;data: UpdateInspectionRequest}, TContext> => {

const mutationKey = ['updateInspection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInspection>>, {id: string;data: UpdateInspectionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateInspection(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInspectionMutationResult = NonNullable<Awaited<ReturnType<typeof updateInspection>>>
    export type UpdateInspectionMutationBody = UpdateInspectionRequest
    export type UpdateInspectionMutationError = ErrorResponse | ValidationErrorResponse

    /**
 * @summary Update inspection
 */
export const useUpdateInspection = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInspection>>, TError,{id: string;data: UpdateInspectionRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateInspection>>,
        TError,
        {id: string;data: UpdateInspectionRequest},
        TContext
      > => {
      return useMutation(getUpdateInspectionMutationOptions(options), queryClient);
    }

export const getListInspectionDocumentsUrl = (id: string,) => {




  return `/api/inspections/${id}/documents`
}

/**
 * @summary List documents for an inspection
 */
export const listInspectionDocuments = async (id: string, options?: RequestInit): Promise<DocumentSummaryResponse[]> => {

  return customFetch<DocumentSummaryResponse[]>(getListInspectionDocumentsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInspectionDocumentsQueryKey = (id: string,) => {
    return [
    `/api/inspections/${id}/documents`
    ] as const;
    }


export const getListInspectionDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listInspectionDocuments>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspectionDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInspectionDocumentsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInspectionDocuments>>> = ({ signal }) => listInspectionDocuments(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInspectionDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInspectionDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listInspectionDocuments>>>
export type ListInspectionDocumentsQueryError = ErrorResponse


export function useListInspectionDocuments<TData = Awaited<ReturnType<typeof listInspectionDocuments>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspectionDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInspectionDocuments>>,
          TError,
          Awaited<ReturnType<typeof listInspectionDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInspectionDocuments<TData = Awaited<ReturnType<typeof listInspectionDocuments>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspectionDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInspectionDocuments>>,
          TError,
          Awaited<ReturnType<typeof listInspectionDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInspectionDocuments<TData = Awaited<ReturnType<typeof listInspectionDocuments>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspectionDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List documents for an inspection
 */

export function useListInspectionDocuments<TData = Awaited<ReturnType<typeof listInspectionDocuments>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspectionDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInspectionDocumentsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListInspectionPhotosUrl = (id: string,) => {




  return `/api/inspections/${id}/photos`
}

/**
 * Returns the photo gallery for the inspection, backed by
 * document-svc. Each entry includes a presigned download URL and any
 * EXIF / upload metadata captured at upload time.
 * @summary List photos for an inspection
 */
export const listInspectionPhotos = async (id: string, options?: RequestInit): Promise<InspectionPhotoResponse[]> => {

  return customFetch<InspectionPhotoResponse[]>(getListInspectionPhotosUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInspectionPhotosQueryKey = (id: string,) => {
    return [
    `/api/inspections/${id}/photos`
    ] as const;
    }


export const getListInspectionPhotosQueryOptions = <TData = Awaited<ReturnType<typeof listInspectionPhotos>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspectionPhotos>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInspectionPhotosQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInspectionPhotos>>> = ({ signal }) => listInspectionPhotos(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInspectionPhotos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInspectionPhotosQueryResult = NonNullable<Awaited<ReturnType<typeof listInspectionPhotos>>>
export type ListInspectionPhotosQueryError = ErrorResponse


export function useListInspectionPhotos<TData = Awaited<ReturnType<typeof listInspectionPhotos>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspectionPhotos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInspectionPhotos>>,
          TError,
          Awaited<ReturnType<typeof listInspectionPhotos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInspectionPhotos<TData = Awaited<ReturnType<typeof listInspectionPhotos>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspectionPhotos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInspectionPhotos>>,
          TError,
          Awaited<ReturnType<typeof listInspectionPhotos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInspectionPhotos<TData = Awaited<ReturnType<typeof listInspectionPhotos>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspectionPhotos>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List photos for an inspection
 */

export function useListInspectionPhotos<TData = Awaited<ReturnType<typeof listInspectionPhotos>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspectionPhotos>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInspectionPhotosQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCompleteInspectionUrl = (id: string,) => {




  return `/api/inspections/${id}/complete`
}

/**
 * **Auth:** inspector floor (inspector, manager, or admin) + site
 * claim. Admin bypasses the site-claim check. Viewers are rejected.
 * @summary Complete an inspection
 */
export const completeInspection = async (id: string,
    completeInspectionRequest: CompleteInspectionRequest, options?: RequestInit): Promise<InspectionResponse> => {

  return customFetch<InspectionResponse>(getCompleteInspectionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(completeInspectionRequest)
  }
);}





export const getCompleteInspectionMutationOptions = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeInspection>>, TError,{id: string;data: CompleteInspectionRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof completeInspection>>, TError,{id: string;data: CompleteInspectionRequest}, TContext> => {

const mutationKey = ['completeInspection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeInspection>>, {id: string;data: CompleteInspectionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  completeInspection(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteInspectionMutationResult = NonNullable<Awaited<ReturnType<typeof completeInspection>>>
    export type CompleteInspectionMutationBody = CompleteInspectionRequest
    export type CompleteInspectionMutationError = ErrorResponse | ValidationErrorResponse

    /**
 * @summary Complete an inspection
 */
export const useCompleteInspection = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeInspection>>, TError,{id: string;data: CompleteInspectionRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeInspection>>,
        TError,
        {id: string;data: CompleteInspectionRequest},
        TContext
      > => {
      return useMutation(getCompleteInspectionMutationOptions(options), queryClient);
    }

export const getApproveInspectionUrl = (id: string,) => {




  return `/api/inspections/${id}/approve`
}

/**
 * A manager accepts a completed inspection's evidence. Only inspections
 * awaiting approval can be approved, and the approver must not be the
 * inspector who completed the work — a second pair of eyes is the whole
 * value of the step.
 *
 * **Auth:** manager floor (manager or admin) + site claim. Admin bypasses
 * the site-claim check. Inspectors and viewers are rejected.
 * @summary Approve a completed inspection
 */
export const approveInspection = async (id: string, options?: RequestInit): Promise<InspectionResponse> => {

  return customFetch<InspectionResponse>(getApproveInspectionUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getApproveInspectionMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveInspection>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveInspection>>, TError,{id: string}, TContext> => {

const mutationKey = ['approveInspection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveInspection>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  approveInspection(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveInspectionMutationResult = NonNullable<Awaited<ReturnType<typeof approveInspection>>>

    export type ApproveInspectionMutationError = ErrorResponse

    /**
 * @summary Approve a completed inspection
 */
export const useApproveInspection = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveInspection>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveInspection>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getApproveInspectionMutationOptions(options), queryClient);
    }

export const getRejectInspectionUrl = (id: string,) => {




  return `/api/inspections/${id}/reject`
}

/**
 * The inspection returns to IN_PROGRESS carrying the reason, so the
 * inspector is told what to fix rather than left to guess. Nothing is
 * deleted — the findings, photos and recorded verifications are all still
 * there to be corrected.
 *
 * **Auth:** manager floor (manager or admin) + site claim. Admin bypasses
 * the site-claim check. Inspectors and viewers are rejected.
 * @summary Send a completed inspection back to the inspector
 */
export const rejectInspection = async (id: string,
    rejectInspectionRequest: RejectInspectionRequest, options?: RequestInit): Promise<InspectionResponse> => {

  return customFetch<InspectionResponse>(getRejectInspectionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(rejectInspectionRequest)
  }
);}





export const getRejectInspectionMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectInspection>>, TError,{id: string;data: RejectInspectionRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectInspection>>, TError,{id: string;data: RejectInspectionRequest}, TContext> => {

const mutationKey = ['rejectInspection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectInspection>>, {id: string;data: RejectInspectionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  rejectInspection(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectInspectionMutationResult = NonNullable<Awaited<ReturnType<typeof rejectInspection>>>
    export type RejectInspectionMutationBody = RejectInspectionRequest
    export type RejectInspectionMutationError = ErrorResponse

    /**
 * @summary Send a completed inspection back to the inspector
 */
export const useRejectInspection = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectInspection>>, TError,{id: string;data: RejectInspectionRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectInspection>>,
        TError,
        {id: string;data: RejectInspectionRequest},
        TContext
      > => {
      return useMutation(getRejectInspectionMutationOptions(options), queryClient);
    }

export const getGetSiteInspectionSettingsUrl = (siteId: string,) => {




  return `/api/sites/${siteId}/inspection-settings`
}

/**
 * A site with no settings of its own runs on the defaults, which is the
 * ordinary state rather than a missing record.
 *
 * **Auth:** viewer floor + site claim.
 * @summary How a site runs its inspections
 */
export const getSiteInspectionSettings = async (siteId: string, options?: RequestInit): Promise<SiteInspectionSettingsDTO> => {

  return customFetch<SiteInspectionSettingsDTO>(getGetSiteInspectionSettingsUrl(siteId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSiteInspectionSettingsQueryKey = (siteId: string,) => {
    return [
    `/api/sites/${siteId}/inspection-settings`
    ] as const;
    }


export const getGetSiteInspectionSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSiteInspectionSettings>>, TError = ErrorResponse>(siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSiteInspectionSettings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSiteInspectionSettingsQueryKey(siteId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSiteInspectionSettings>>> = ({ signal }) => getSiteInspectionSettings(siteId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: siteId !== null && siteId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSiteInspectionSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSiteInspectionSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSiteInspectionSettings>>>
export type GetSiteInspectionSettingsQueryError = ErrorResponse


export function useGetSiteInspectionSettings<TData = Awaited<ReturnType<typeof getSiteInspectionSettings>>, TError = ErrorResponse>(
 siteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSiteInspectionSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSiteInspectionSettings>>,
          TError,
          Awaited<ReturnType<typeof getSiteInspectionSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSiteInspectionSettings<TData = Awaited<ReturnType<typeof getSiteInspectionSettings>>, TError = ErrorResponse>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSiteInspectionSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSiteInspectionSettings>>,
          TError,
          Awaited<ReturnType<typeof getSiteInspectionSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSiteInspectionSettings<TData = Awaited<ReturnType<typeof getSiteInspectionSettings>>, TError = ErrorResponse>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSiteInspectionSettings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary How a site runs its inspections
 */

export function useGetSiteInspectionSettings<TData = Awaited<ReturnType<typeof getSiteInspectionSettings>>, TError = ErrorResponse>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSiteInspectionSettings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSiteInspectionSettingsQueryOptions(siteId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateSiteInspectionSettingsUrl = (siteId: string,) => {




  return `/api/sites/${siteId}/inspection-settings`
}

/**
 * Only inspections completed AFTER the change are affected. Every
 * inspection carries the rule it was completed under, so turning approval
 * on does not sweep finished work into a queue, and turning it off does
 * not silently approve what is already waiting.
 *
 * **Auth:** manager floor (manager or admin) + site claim.
 * @summary Change how a site runs its inspections
 */
export const updateSiteInspectionSettings = async (siteId: string,
    updateSiteInspectionSettingsRequest: UpdateSiteInspectionSettingsRequest, options?: RequestInit): Promise<SiteInspectionSettingsDTO> => {

  return customFetch<SiteInspectionSettingsDTO>(getUpdateSiteInspectionSettingsUrl(siteId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateSiteInspectionSettingsRequest)
  }
);}





export const getUpdateSiteInspectionSettingsMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSiteInspectionSettings>>, TError,{siteId: string;data: UpdateSiteInspectionSettingsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSiteInspectionSettings>>, TError,{siteId: string;data: UpdateSiteInspectionSettingsRequest}, TContext> => {

const mutationKey = ['updateSiteInspectionSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSiteInspectionSettings>>, {siteId: string;data: UpdateSiteInspectionSettingsRequest}> = (props) => {
          const {siteId,data} = props ?? {};

          return  updateSiteInspectionSettings(siteId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSiteInspectionSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateSiteInspectionSettings>>>
    export type UpdateSiteInspectionSettingsMutationBody = UpdateSiteInspectionSettingsRequest
    export type UpdateSiteInspectionSettingsMutationError = ErrorResponse

    /**
 * @summary Change how a site runs its inspections
 */
export const useUpdateSiteInspectionSettings = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSiteInspectionSettings>>, TError,{siteId: string;data: UpdateSiteInspectionSettingsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSiteInspectionSettings>>,
        TError,
        {siteId: string;data: UpdateSiteInspectionSettingsRequest},
        TContext
      > => {
      return useMutation(getUpdateSiteInspectionSettingsMutationOptions(options), queryClient);
    }

export const getGetSiteInspectionScheduleUrl = (siteId: string,) => {




  return `/api/sites/${siteId}/inspection-schedule`
}

/**
 * The per-site schedule that equipment-svc computes each tag's next
 * inspection from: site limits, one row per zone group and result
 * modifiers. A site with no saved schedule runs on the defaults
 * and answers with `isDefault: true`.
 *
 * **Auth:** viewer floor + site claim.
 * @summary A site's inspection schedule
 */
export const getSiteInspectionSchedule = async (siteId: string, options?: RequestInit): Promise<SiteScheduleSettingsDTO> => {

  return customFetch<SiteScheduleSettingsDTO>(getGetSiteInspectionScheduleUrl(siteId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSiteInspectionScheduleQueryKey = (siteId: string,) => {
    return [
    `/api/sites/${siteId}/inspection-schedule`
    ] as const;
    }


export const getGetSiteInspectionScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getSiteInspectionSchedule>>, TError = ErrorResponse>(siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSiteInspectionSchedule>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSiteInspectionScheduleQueryKey(siteId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSiteInspectionSchedule>>> = ({ signal }) => getSiteInspectionSchedule(siteId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: siteId !== null && siteId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSiteInspectionSchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSiteInspectionScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getSiteInspectionSchedule>>>
export type GetSiteInspectionScheduleQueryError = ErrorResponse


export function useGetSiteInspectionSchedule<TData = Awaited<ReturnType<typeof getSiteInspectionSchedule>>, TError = ErrorResponse>(
 siteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSiteInspectionSchedule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSiteInspectionSchedule>>,
          TError,
          Awaited<ReturnType<typeof getSiteInspectionSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSiteInspectionSchedule<TData = Awaited<ReturnType<typeof getSiteInspectionSchedule>>, TError = ErrorResponse>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSiteInspectionSchedule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSiteInspectionSchedule>>,
          TError,
          Awaited<ReturnType<typeof getSiteInspectionSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSiteInspectionSchedule<TData = Awaited<ReturnType<typeof getSiteInspectionSchedule>>, TError = ErrorResponse>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSiteInspectionSchedule>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A site's inspection schedule
 */

export function useGetSiteInspectionSchedule<TData = Awaited<ReturnType<typeof getSiteInspectionSchedule>>, TError = ErrorResponse>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSiteInspectionSchedule>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSiteInspectionScheduleQueryOptions(siteId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateSiteInspectionScheduleUrl = (siteId: string,) => {




  return `/api/sites/${siteId}/inspection-schedule`
}

/**
 * Full replace. The document in the request is the document the site
 * runs on from now. The service validates it against the fixed bounds,
 * writes an audit row (who, when, before, after) and publishes
 * `inspection.site.schedule.updated` through the outbox so equipment-svc
 * replaces its projection.
 *
 * Validation: a zone row needs at least one clock; each set clock is
 * 1–96 months; `visualMonths` ≤ `closeMonths` ≤ `detailedMonths` when
 * set; the shortest set clock is at most 48 and at most
 * `maxFixedMonths`; `maxFixedMonths` 1–48, above 36 needs
 * `maxFixedJustification` of at least 20 characters. A document in the
 * previous shape (`grade`, `intervalMonths`, `detailedEveryMonths`) is
 * accepted and converted, and an `overrides` array is ignored.
 *
 * **Auth:** manager floor (manager or admin) + site claim.
 * @summary Replace a site's inspection schedule
 */
export const updateSiteInspectionSchedule = async (siteId: string,
    updateSiteScheduleSettingsRequest: UpdateSiteScheduleSettingsRequest, options?: RequestInit): Promise<SiteScheduleSettingsDTO> => {

  return customFetch<SiteScheduleSettingsDTO>(getUpdateSiteInspectionScheduleUrl(siteId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateSiteScheduleSettingsRequest)
  }
);}





export const getUpdateSiteInspectionScheduleMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSiteInspectionSchedule>>, TError,{siteId: string;data: UpdateSiteScheduleSettingsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSiteInspectionSchedule>>, TError,{siteId: string;data: UpdateSiteScheduleSettingsRequest}, TContext> => {

const mutationKey = ['updateSiteInspectionSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSiteInspectionSchedule>>, {siteId: string;data: UpdateSiteScheduleSettingsRequest}> = (props) => {
          const {siteId,data} = props ?? {};

          return  updateSiteInspectionSchedule(siteId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSiteInspectionScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof updateSiteInspectionSchedule>>>
    export type UpdateSiteInspectionScheduleMutationBody = UpdateSiteScheduleSettingsRequest
    export type UpdateSiteInspectionScheduleMutationError = ErrorResponse

    /**
 * @summary Replace a site's inspection schedule
 */
export const useUpdateSiteInspectionSchedule = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSiteInspectionSchedule>>, TError,{siteId: string;data: UpdateSiteScheduleSettingsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSiteInspectionSchedule>>,
        TError,
        {siteId: string;data: UpdateSiteScheduleSettingsRequest},
        TContext
      > => {
      return useMutation(getUpdateSiteInspectionScheduleMutationOptions(options), queryClient);
    }

export const getCancelInspectionUrl = (id: string,) => {




  return `/api/inspections/${id}/cancel`
}

/**
 * Cancels a non-terminal inspection (UPCOMING / PLANNING / SCHEDULED /
 * IN_PROGRESS → CANCELLED). Returns 409 if the inspection is already COMPLETED or
 * CANCELLED. When linked to a SOW, triggers the SOW completion check —
 * if the cancellation leaves the SOW with every child in a terminal
 * state, the SOW auto-promotes to COMPLETED.
 * @summary Cancel an inspection
 */
export const cancelInspection = async (id: string, options?: RequestInit): Promise<InspectionResponse> => {

  return customFetch<InspectionResponse>(getCancelInspectionUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelInspectionMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelInspection>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelInspection>>, TError,{id: string}, TContext> => {

const mutationKey = ['cancelInspection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelInspection>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelInspection(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelInspectionMutationResult = NonNullable<Awaited<ReturnType<typeof cancelInspection>>>

    export type CancelInspectionMutationError = ErrorResponse

    /**
 * @summary Cancel an inspection
 */
export const useCancelInspection = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelInspection>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelInspection>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getCancelInspectionMutationOptions(options), queryClient);
    }

export const getStartInspectionUrl = (id: string,) => {




  return `/api/inspections/${id}/start`
}

/**
 * Transitions the inspection from SCHEDULED or UPCOMING to IN_PROGRESS,
 * sets the inspector name from the authenticated user, and activates
 * the parent scope of work. Starting an UPCOMING inspection is how an
 * inspector picks it up.
 *
 * **Auth:** inspector floor (inspector, manager, or admin) + site
 * claim. Admin bypasses the site-claim check. Viewers are rejected.
 * @summary Start an inspection
 */
export const startInspection = async (id: string, options?: RequestInit): Promise<InspectionResponse> => {

  return customFetch<InspectionResponse>(getStartInspectionUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getStartInspectionMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startInspection>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startInspection>>, TError,{id: string}, TContext> => {

const mutationKey = ['startInspection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startInspection>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  startInspection(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartInspectionMutationResult = NonNullable<Awaited<ReturnType<typeof startInspection>>>

    export type StartInspectionMutationError = ErrorResponse

    /**
 * @summary Start an inspection
 */
export const useStartInspection = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startInspection>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startInspection>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getStartInspectionMutationOptions(options), queryClient);
    }

export const getGetHACFormUrl = (id: string,) => {




  return `/api/inspections/${id}/hac-form`
}

/**
 * Returns the HAC form previously submitted against this inspection,
 * including all check item results and fittings rows. Returns 404 if
 * no form has been submitted yet.
 *
 * **Auth:** authenticated + site claim on the loaded form's site.
 * Admin bypasses the site-claim check. The claim check runs after the
 * form is loaded so callers cannot probe inspection IDs across sites.
 * @summary Get the digital HAC form attached to an inspection
 */
export const getHACForm = async (id: string, options?: RequestInit): Promise<HACFormResponse> => {

  return customFetch<HACFormResponse>(getGetHACFormUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHACFormQueryKey = (id: string,) => {
    return [
    `/api/inspections/${id}/hac-form`
    ] as const;
    }


export const getGetHACFormQueryOptions = <TData = Awaited<ReturnType<typeof getHACForm>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHACForm>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHACFormQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHACForm>>> = ({ signal }) => getHACForm(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHACForm>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHACFormQueryResult = NonNullable<Awaited<ReturnType<typeof getHACForm>>>
export type GetHACFormQueryError = ErrorResponse


export function useGetHACForm<TData = Awaited<ReturnType<typeof getHACForm>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHACForm>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHACForm>>,
          TError,
          Awaited<ReturnType<typeof getHACForm>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHACForm<TData = Awaited<ReturnType<typeof getHACForm>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHACForm>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHACForm>>,
          TError,
          Awaited<ReturnType<typeof getHACForm>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHACForm<TData = Awaited<ReturnType<typeof getHACForm>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHACForm>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the digital HAC form attached to an inspection
 */

export function useGetHACForm<TData = Awaited<ReturnType<typeof getHACForm>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHACForm>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHACFormQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubmitHACFormUrl = (id: string,) => {




  return `/api/inspections/${id}/hac-form`
}

/**
 * Persists a complete HAC form (Gas or Dust variant) and publishes a
 * `HACFormSubmitted` event. Each REJECT check item triggers a defect
 * in defect-svc. Submission is one-shot per inspection — re-submitting
 * returns 409.
 *
 * **Auth:** inspector floor (inspector, manager, or admin) + site
 * claim. Admin bypasses the site-claim check. Viewers are rejected.
 * @summary Submit a digital HAC form against an inspection
 */
export const submitHACForm = async (id: string,
    submitHACFormRequest: SubmitHACFormRequest, options?: RequestInit): Promise<HACFormResponse> => {

  return customFetch<HACFormResponse>(getSubmitHACFormUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submitHACFormRequest)
  }
);}





export const getSubmitHACFormMutationOptions = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitHACForm>>, TError,{id: string;data: SubmitHACFormRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitHACForm>>, TError,{id: string;data: SubmitHACFormRequest}, TContext> => {

const mutationKey = ['submitHACForm'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitHACForm>>, {id: string;data: SubmitHACFormRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  submitHACForm(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitHACFormMutationResult = NonNullable<Awaited<ReturnType<typeof submitHACForm>>>
    export type SubmitHACFormMutationBody = SubmitHACFormRequest
    export type SubmitHACFormMutationError = ErrorResponse | ValidationErrorResponse

    /**
 * @summary Submit a digital HAC form against an inspection
 */
export const useSubmitHACForm = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitHACForm>>, TError,{id: string;data: SubmitHACFormRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitHACForm>>,
        TError,
        {id: string;data: SubmitHACFormRequest},
        TContext
      > => {
      return useMutation(getSubmitHACFormMutationOptions(options), queryClient);
    }

export const getSwitchRecordingMethodUrl = (id: string,) => {




  return `/api/inspections/${id}/recording-method/reset`
}

/**
 * Clears any DRAFT HAC form (cascading check items + fittings) and
 * detaches an uploaded paper inspection sheet. Manually entered
 * defects are preserved. Returns 409 if a HAC form has already been
 * SUBMITTED — those are immutable through this path.
 *
 * **Auth:** inspector floor (inspector, manager, or admin) + site
 * claim. Admin bypasses the site-claim check. Viewers are rejected.
 * @summary Discard in-progress recording state so the inspector can switch methods
 */
export const switchRecordingMethod = async (id: string, options?: RequestInit): Promise<InspectionResponse> => {

  return customFetch<InspectionResponse>(getSwitchRecordingMethodUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSwitchRecordingMethodMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchRecordingMethod>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof switchRecordingMethod>>, TError,{id: string}, TContext> => {

const mutationKey = ['switchRecordingMethod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof switchRecordingMethod>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  switchRecordingMethod(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SwitchRecordingMethodMutationResult = NonNullable<Awaited<ReturnType<typeof switchRecordingMethod>>>

    export type SwitchRecordingMethodMutationError = ErrorResponse

    /**
 * @summary Discard in-progress recording state so the inspector can switch methods
 */
export const useSwitchRecordingMethod = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchRecordingMethod>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof switchRecordingMethod>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getSwitchRecordingMethodMutationOptions(options), queryClient);
    }

export const getUpsertHACFormDraftUrl = (id: string,) => {




  return `/api/inspections/${id}/hac-form/draft`
}

/**
 * Idempotent autosave endpoint. Soft validation only: missing answers,
 * unsigned signoffs, and partial fittings are all allowed. Calling
 * `submitHACForm` later flushes the draft and transitions to SUBMITTED.
 *
 * **Auth:** inspector floor (inspector, manager, or admin) + site
 * claim. Admin bypasses the site-claim check. Viewers are rejected.
 * @summary Save (or update) a draft HAC form for an inspection
 */
export const upsertHACFormDraft = async (id: string,
    upsertHACFormDraftRequest: UpsertHACFormDraftRequest, options?: RequestInit): Promise<HACFormResponse> => {

  return customFetch<HACFormResponse>(getUpsertHACFormDraftUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(upsertHACFormDraftRequest)
  }
);}





export const getUpsertHACFormDraftMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertHACFormDraft>>, TError,{id: string;data: UpsertHACFormDraftRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertHACFormDraft>>, TError,{id: string;data: UpsertHACFormDraftRequest}, TContext> => {

const mutationKey = ['upsertHACFormDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertHACFormDraft>>, {id: string;data: UpsertHACFormDraftRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  upsertHACFormDraft(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertHACFormDraftMutationResult = NonNullable<Awaited<ReturnType<typeof upsertHACFormDraft>>>
    export type UpsertHACFormDraftMutationBody = UpsertHACFormDraftRequest
    export type UpsertHACFormDraftMutationError = ErrorResponse

    /**
 * @summary Save (or update) a draft HAC form for an inspection
 */
export const useUpsertHACFormDraft = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertHACFormDraft>>, TError,{id: string;data: UpsertHACFormDraftRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upsertHACFormDraft>>,
        TError,
        {id: string;data: UpsertHACFormDraftRequest},
        TContext
      > => {
      return useMutation(getUpsertHACFormDraftMutationOptions(options), queryClient);
    }

export const getListFieldVerificationsUrl = (id: string,) => {




  return `/api/inspections/${id}/field-verifications`
}

/**
 * Returns every equipment field the inspector has confirmed on site for
 * this inspection, each with the immutable `verifiedValue` snapshot. The
 * iPlant verify-equipment-details step uses this to render which fields
 * are already ticked.
 *
 * **Auth:** authenticated + site claim on the inspection's site. Admin
 * bypasses the site-claim check.
 * @summary List on-site field verifications recorded for an inspection
 */
export const listFieldVerifications = async (id: string, options?: RequestInit): Promise<FieldVerificationListResponse> => {

  return customFetch<FieldVerificationListResponse>(getListFieldVerificationsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListFieldVerificationsQueryKey = (id: string,) => {
    return [
    `/api/inspections/${id}/field-verifications`
    ] as const;
    }


export const getListFieldVerificationsQueryOptions = <TData = Awaited<ReturnType<typeof listFieldVerifications>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFieldVerifications>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFieldVerificationsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFieldVerifications>>> = ({ signal }) => listFieldVerifications(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFieldVerifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListFieldVerificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listFieldVerifications>>>
export type ListFieldVerificationsQueryError = ErrorResponse


export function useListFieldVerifications<TData = Awaited<ReturnType<typeof listFieldVerifications>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFieldVerifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFieldVerifications>>,
          TError,
          Awaited<ReturnType<typeof listFieldVerifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFieldVerifications<TData = Awaited<ReturnType<typeof listFieldVerifications>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFieldVerifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFieldVerifications>>,
          TError,
          Awaited<ReturnType<typeof listFieldVerifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFieldVerifications<TData = Awaited<ReturnType<typeof listFieldVerifications>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFieldVerifications>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List on-site field verifications recorded for an inspection
 */

export function useListFieldVerifications<TData = Awaited<ReturnType<typeof listFieldVerifications>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFieldVerifications>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListFieldVerificationsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRecordFieldVerificationUrl = (id: string,
    field: string,) => {




  return `/api/inspections/${id}/field-verifications/${field}`
}

/**
 * Upserts the inspector's confirmation of a single equipment field for an
 * IN_PROGRESS inspection. `verifiedValue` is the immutable compliance
 * snapshot of the value confirmed on site; omit/null it to record a
 * confirmed-empty field.
 *
 * **Correct-then-verify:** if the on-site value is wrong, correct it first
 * via the normal equipment PATCH (logged MANUAL by Phase 1 provenance),
 * then call this to verify the resulting value. This endpoint does not
 * change the equipment value — it only records the confirmation.
 *
 * **Auth:** inspector floor (inspector, manager, or admin) + site claim.
 * Admin bypasses the site-claim check. Viewers are rejected.
 * @summary Record (or re-record) an on-site verification of one equipment field
 */
export const recordFieldVerification = async (id: string,
    field: string,
    recordFieldVerificationRequest: RecordFieldVerificationRequest, options?: RequestInit): Promise<FieldVerificationResponse> => {

  return customFetch<FieldVerificationResponse>(getRecordFieldVerificationUrl(id,field),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(recordFieldVerificationRequest)
  }
);}





export const getRecordFieldVerificationMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordFieldVerification>>, TError,{id: string;field: string;data: RecordFieldVerificationRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordFieldVerification>>, TError,{id: string;field: string;data: RecordFieldVerificationRequest}, TContext> => {

const mutationKey = ['recordFieldVerification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordFieldVerification>>, {id: string;field: string;data: RecordFieldVerificationRequest}> = (props) => {
          const {id,field,data} = props ?? {};

          return  recordFieldVerification(id,field,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordFieldVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof recordFieldVerification>>>
    export type RecordFieldVerificationMutationBody = RecordFieldVerificationRequest
    export type RecordFieldVerificationMutationError = ErrorResponse

    /**
 * @summary Record (or re-record) an on-site verification of one equipment field
 */
export const useRecordFieldVerification = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordFieldVerification>>, TError,{id: string;field: string;data: RecordFieldVerificationRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordFieldVerification>>,
        TError,
        {id: string;field: string;data: RecordFieldVerificationRequest},
        TContext
      > => {
      return useMutation(getRecordFieldVerificationMutationOptions(options), queryClient);
    }

export const getClearFieldVerificationUrl = (id: string,
    field: string,) => {




  return `/api/inspections/${id}/field-verifications/${field}`
}

/**
 * Removes the inspector's confirmation of a single equipment field for an
 * IN_PROGRESS inspection. Idempotent: clearing an un-verified field
 * returns 204 with no effect.
 *
 * **Auth:** inspector floor (inspector, manager, or admin) + site claim.
 * Admin bypasses the site-claim check. Viewers are rejected.
 * @summary Clear an on-site field verification
 */
export const clearFieldVerification = async (id: string,
    field: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getClearFieldVerificationUrl(id,field),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getClearFieldVerificationMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearFieldVerification>>, TError,{id: string;field: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof clearFieldVerification>>, TError,{id: string;field: string}, TContext> => {

const mutationKey = ['clearFieldVerification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearFieldVerification>>, {id: string;field: string}> = (props) => {
          const {id,field} = props ?? {};

          return  clearFieldVerification(id,field,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearFieldVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof clearFieldVerification>>>

    export type ClearFieldVerificationMutationError = ErrorResponse

    /**
 * @summary Clear an on-site field verification
 */
export const useClearFieldVerification = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearFieldVerification>>, TError,{id: string;field: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearFieldVerification>>,
        TError,
        {id: string;field: string},
        TContext
      > => {
      return useMutation(getClearFieldVerificationMutationOptions(options), queryClient);
    }

export const getGetHACFormCatalogUrl = (variant: 'GAS' | 'DUST',
    params?: GetHACFormCatalogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hac-form-catalog/${variant}?${stringifiedParams}` : `/api/hac-form-catalog/${variant}`
}

/**
 * Returns the ordered list of check items that make up the printed
 * Gas or Dust HAC form. Frontend and Android clients use this to
 * render the form so the catalog stays a single source of truth.
 *
 * Pass `inspectionId` to get the list the equipment actually needs.
 * The server reads the equipment's Ex Type and removes every additional
 * check section the equipment does not use, so the digital form shows
 * exactly the sections the printed field sheet shows. Items 1-27 always
 * stay. Equipment with no readable Ex Type keeps every section and the
 * response sets `protectionUnknown`.
 *
 * Without `inspectionId` the response holds the whole catalog.
 *
 * The scoped form checks the caller's claim on the inspection's site, so
 * nobody can read another site's Ex-Type-derived sections. Admin bypasses
 * the site-claim check.
 * @summary Get the static check-item catalog for a HAC form variant
 */
export const getHACFormCatalog = async (variant: 'GAS' | 'DUST',
    params?: GetHACFormCatalogParams, options?: RequestInit): Promise<HACFormCatalogResponse> => {

  return customFetch<HACFormCatalogResponse>(getGetHACFormCatalogUrl(variant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHACFormCatalogQueryKey = (variant: 'GAS' | 'DUST',
    params?: GetHACFormCatalogParams,) => {
    return [
    `/api/hac-form-catalog/${variant}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetHACFormCatalogQueryOptions = <TData = Awaited<ReturnType<typeof getHACFormCatalog>>, TError = ErrorResponse>(variant: 'GAS' | 'DUST',
    params?: GetHACFormCatalogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHACFormCatalog>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHACFormCatalogQueryKey(variant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHACFormCatalog>>> = ({ signal }) => getHACFormCatalog(variant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: variant !== null && variant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHACFormCatalog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHACFormCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof getHACFormCatalog>>>
export type GetHACFormCatalogQueryError = ErrorResponse


export function useGetHACFormCatalog<TData = Awaited<ReturnType<typeof getHACFormCatalog>>, TError = ErrorResponse>(
 variant: 'GAS' | 'DUST',
    params: undefined |  GetHACFormCatalogParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHACFormCatalog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHACFormCatalog>>,
          TError,
          Awaited<ReturnType<typeof getHACFormCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHACFormCatalog<TData = Awaited<ReturnType<typeof getHACFormCatalog>>, TError = ErrorResponse>(
 variant: 'GAS' | 'DUST',
    params?: GetHACFormCatalogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHACFormCatalog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHACFormCatalog>>,
          TError,
          Awaited<ReturnType<typeof getHACFormCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHACFormCatalog<TData = Awaited<ReturnType<typeof getHACFormCatalog>>, TError = ErrorResponse>(
 variant: 'GAS' | 'DUST',
    params?: GetHACFormCatalogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHACFormCatalog>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the static check-item catalog for a HAC form variant
 */

export function useGetHACFormCatalog<TData = Awaited<ReturnType<typeof getHACFormCatalog>>, TError = ErrorResponse>(
 variant: 'GAS' | 'DUST',
    params?: GetHACFormCatalogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHACFormCatalog>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHACFormCatalogQueryOptions(variant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







